export default __webpack_public_path__ + "static/media/images-2.bd37db21.jpg";